import { CountryState } from '../../index';

export class DBUpdateMessage{
    message: string;
    code: Number;
}

export enum STATUS{
    NEW = "0",
    MODIFIED = "1",
    UPLOADED = "2",
    STORED = "3",
    OPEN = "4",
    CLOSED = "5"
}

export class Person{
    phone : string;
    email : string;
    password : string;
    name : string;
    address1 : string;
    address2 : string;
    city : string;
    state : string;
    selectedstate: string;
 
    zip : string;
    markedfordelete = false;
    docid : string;
}

export class Signup extends Person {
    statefound: boolean;
    SeletectedCS: CountryState;
    status = STATUS.NEW;
    constructor(){
        super();
    }
}

export class JSONSignup extends Person{
   // docid: string;
    ts: number;
    countryname : string;
    // zip : string;
    status : string;
    constructor(person: Signup){
        super();
        this.docid = person.docid;
        this.ts = Date.now();
        this.phone = person.phone["e164Number"];
        this.email = person.email;
        this.password = person.password;
        this.name = person.name;
        this.address1 = person.address1;
        this.address2 = person.address2;
        this.city = person.city;
        this.selectedstate = person.selectedstate;
        this.zip = person.zip;
        this.markedfordelete = person.markedfordelete;
        this.status = person.status;
    }
}